import React, { useContext } from 'react';
import { string, func } from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Route, ScrollToTop, Switch } from '@thd-olt-component-react/router';
import { Error } from './pages';
import { getRoutes } from './routes';

import './styles/app.scss';
import './styles/global-styles.scss';

export const App = ({ pipTimeout }) => {
  const { instance } = useContext(AppContext);

  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent);
  const { channel } = useContext(ExperienceContext);

  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route exact path={routes.selfDropoff.path}>
          <routes.selfDropoff.component />
        </Route>
        <Route exact path={routes.cancelReservation.path}>
          <routes.cancelReservation.component />
        </Route>
        <Route exact path={routes.reservationDetails.path}> {/* TODO: TODO: Remove once transitioned off */}
          <routes.reservationDetails.component />
        </Route>
        <Route exact path={routes.reservation.path}>
          <routes.reservation.component />
        </Route>
        <Route exact path={routes.product.path}>
          <routes.product.component />
        </Route>
        <Route path="/error">
          <Error />
        </Route>
        <Route>
          <Error />
        </Route>
      </Switch>
    </>
  );
};

App.propTypes = {
  pipTimeout: string
};

App.defaultProps = {
  pipTimeout: null
};